<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="resetLeftFilter">
          <span>创建时间:</span>
          <e-date-picker
            type="daterange"
            :value.sync="create_date"
            isShowFast
            @change="resetLeftFilter"
          />
        </el-form>
      </div>
    </div>

    <div class="flex w-100">
      <b-filter-left
        ref="refLeftFilter"
        :init_filter_data="init_filter_data"
        :search_data="search_data"
        @success="updateLeftFilter"
      />
      <div class="flex-1 w-0">
        <!-- 表格操作条 -->
        <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
          <template #buttons>
            <el-button type="primary" size="mini" @click="batchDo('启用')"> 启用 </el-button>
            <el-button type="info" size="mini" @click="batchDo('禁用')"> 禁用 </el-button>
            <el-button type="danger" size="mini" @click="batchDo('删除')"> 删除 </el-button>
          </template>
          <template #tools>
            <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()"
              >新增工艺
            </el-button>
          </template>
        </vxe-toolbar>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 187"
          @cell-dblclick="itemDbDo"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
          @resizable-change="handleColumnResize"
        >
          <!-- slot_default -->
          <template #default_code="{ row }">
            <el-link type="primary" @click="itemDo(row.id)">
              {{ row.code }}
            </el-link>
          </template>
          <template #default_she_bei_list="{ row }">
            <el-link @click="itemBindSheBei(row)" type="primary">
              绑定({{ row.she_bei_list ? row.she_bei_list.length : 0 }})
            </el-link>
          </template>
          <template #default_gong_xu_list="{ row }">
            <div v-if="row.gong_xu_list.length" class="sort-box" @click="itemBindGongXu(row)">
              <div v-for="(item, index) in row.gong_xu_list" :key="index" class="sort-item">
                <span v-if="index" class="iconfont icon-arrow-right"></span>
                <span>{{ item.name || '空' }}</span>
              </div>
            </div>
            <el-link v-else type="primary" @click="itemBindGongXu(row)">绑定工序</el-link>
          </template>
          <template #default_ststus="{ row }">
            <el-switch type="primary" v-model="row.status" @change="itemSwitch(row)" />
          </template>
          <template #default_create_date="{ row }">
            {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
          </template>
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="itemDo(row.id)">
                  <span class="c-blue">编辑</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemDelete(row)">
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </div>

    <!-- 弹窗-新增工艺 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="activeId"
      @success="updatePage"
    />

    <!-- 弹窗-绑定设备 -->
    <PopupBindSheBei
      v-if="isShowPopupBindSheBei"
      :show.sync="isShowPopupBindSheBei"
      :list="activeData.she_bei_list"
      @success="itemBindSheBeiSuccess"
    />

    <!-- 弹窗-绑定工序 -->
    <PopupBindGongXu
      v-if="isShowPopupBindGongXu"
      :show.sync="isShowPopupBindGongXu"
      :list="activeData.gong_xu_list"
      @success="itemBindGongXuSuccess"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_gongyi_page_list',
  components: {
    PopupDo: () => import('../common/popup-do'),
    PopupBindSheBei: () => import('../common/popup-bind-she-bei'),
    PopupBindGongXu: () => import('../common/popup-bind-gong-xu')
  },
  data() {
    return {
      loading: true,

      // filter
      create_date: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
      sortData: {
        id: 'desc'
      },
      init_filter_data: {
        active_parent_key: '工艺名称',
        active_search_type: '工艺',
        hide_count_keys: [],
        api_url_parent: '/admin/gcvip/gongyi/leftFatherFilter3',
        api_url_child: '/admin/gcvip/gongyi/leftFilter3'
      },
      left_filter_data: {
        type: '工艺',
        list: []
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },

      isShowPopupDo: false,
      isShowPopupBindSheBei: false,
      isShowPopupBindGongXu: false,
      activeId: null,
      activeData: {}
    }
  },
  computed: {
    search_data() {
      let result = {
        create_date: this.create_date || []
      }
      return result
    },
    accountId() {
      return this.$store.state.loginAccount.id
    },
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '工艺编码',
          field: 'code',
          slots: { default: 'default_code' },
          width: 80
        },
        {
          title: '工艺名称',
          field: 'mu_ban_ming_cheng'
        },
        {
          title: '关联类目',
          field: 'lei_mu_name'
        },
        {
          title: '工艺描述',
          field: 'gong_yi_bei_zhu'
        },
        {
          title: '创建人',
          field: 'create_name'
        },
        {
          title: '创建时间',
          field: 'create_date',
          slots: { default: 'default_create_date' }
        },
        {
          field: 'she_bei_list',
          title: '关联设备',
          slots: { default: 'default_she_bei_list' },
          width: 80
        },
        {
          field: 'gong_xu_list',
          title: '工序组成',
          slots: { default: 'default_gong_xu_list' },
          width: 300
        },
        {
          field: 'status',
          title: '状态',
          width: 80,
          slots: { default: 'default_ststus' }
        },
        {
          fixed: 'right',
          title: '操作',
          width: 73,
          slots: { default: 'default_operate' }
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.$refs.refLeftFilter.updateFilterGroupData()
      this.searchListData()
    },
    // 重置左侧筛选
    resetLeftFilter() {
      if (!this.left_filter_data.list.length) {
        let result = {
          type: this.init_filter_data.active_search_type,
          list: []
        }
        this.updateLeftFilter(result)
      }
    },
    // 更新左侧筛选
    updateLeftFilter(val) {
      this.left_filter_data = this.$util.deepCopy(val)
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true

      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        create_date: this.search_data.create_date,
        sortData: this.$util.deepCopy(this.sortData)
      }
      if (this.left_filter_data.list.length) params.left_filter = this.left_filter_data.list

      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/list3',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 项-增改
    itemDo(id = null) {
      this.activeId = id
      this.isShowPopupDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.id)
    },
    // 项-绑定设备
    itemBindSheBei(row) {
      this.activeData = this.$util.deepCopy(row)
      this.isShowPopupBindSheBei = true
    },
    // 项-绑定设备-成功
    itemBindSheBeiSuccess(data) {
      this.activeData.she_bei_list = data
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/saveOrUpdate',
        data: this.activeData
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('绑定成功')
            this.activeData = {}
            this.updatePage()
          }
        })
        .catch(() => {})
    },
    // 项-绑定工序
    itemBindGongXu(row) {
      this.activeData = this.$util.deepCopy(row)
      this.isShowPopupBindGongXu = true
    },
    // 项-绑定工序-成功
    itemBindGongXuSuccess(data) {
      this.activeData.gong_xu_list = data
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/saveOrUpdate',
        data: this.activeData
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('绑定成功')
            this.activeData = {}
            this.updatePage()
          }
        })
        .catch(() => {})
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          let params = {
            ids: [row.id],
            type: '删除'
          }
          this.batchDoConfirm(params)
        })
        .catch(() => {})
    },
    // 项-切换状态
    itemSwitch(row) {
      let params = {
        ids: [row.id],
        type: row.status ? '启用' : '禁用'
      }
      this.batchDoConfirm(params)
    },
    // 批量-切换状态
    batchDo(type) {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        this.$confirm(`您确认要 "批量${type}" 选中的 "${rows.length}" 项数据?`, '提示')
          .then(() => {
            let params = {
              ids: rows.map((item) => item.id),
              type
            }
            this.batchDoConfirm(params)
          })
          .catch(() => {})
      } else {
        this.itemChoosePrompt()
      }
    },
    // 批量操作-确认
    batchDoConfirm(data) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/batch',
        data
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('操作成功')
          this.updatePage()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  .sort-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    padding: 0 5px;
    color: @colorWhite;
    background-color: @colorBlue;
    border-radius: 2px;
    cursor: pointer;
    .sort-item {
      display: flex;
      align-items: center;
      justify-content: center;
      .iconfont {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        width: 20px;
      }
    }
  }
}
</style>
